
    <form [formGroup]="form" class="container-fluid" autocomplete="off">
        <div class="animated fadeIn">

            <h4>Reasignación de PCF</h4>

            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos para la reasignación de PCF
                            </div>
                        </a>

                        <div class="card-body-detalle mb-3">
                            <div>
                                <div class="row">

                                    <!-- Punto de Inspección -->
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="intEstado">Punto de Inspección</label>
                                        <ng-select [items]="listPuntoInspeccion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPuntoInspeccion"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPuntoInspeccion"
                                                   notFoundText="Punto de Inspección no encontrado"
                                                   placeholder="-- Seleccione un Punto de Inspección --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                                   (change)="onSelectPuntoInspeccion()">
                                        </ng-select>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                            Punto de Inspección es obligatorio
                                        </div>
                                    </div>

                                    <!-- Ubicación -->
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoUbicacion }" for="">Ubicación</label>
                                        <ng-select [items]="listUbicacion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdUbicacion"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listUbicacion && (form.value.IdPuntoInspeccion > 0))"
                                                   notFoundText="Ubicación no encontrada"
                                                   placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                                   [ngClass]="displayFieldCssNgSelect('IdUbicacion')"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectUbicacion()">
                                        </ng-select>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUbicacion','required')">
                                            Ubicación o Instalación Autorizada son obligatorias
                                        </div>
                                    </div>

                                    <!-- Instalacion Autorizada -->
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoInstalacion }" for="">Instalación Autorizada</label>
                                        <ng-select [items]="listInstalacionAutorizada"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdInstalacionAutorizada"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listInstalacionAutorizada && (form.value.IdPuntoInspeccion > 0))"
                                                   notFoundText="Instalación Autorizada no encontrada"
                                                   placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                                   [ngClass]="displayFieldCssNgSelect('IdInstalacionAutorizada')"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectInstalacionAutorizada()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdInstalacionAutorizada','required')">
                                            Instalación Autorizada o Ubicación son obligatorias
                                        </div>
                                    </div>

                                    <!--Hora Reasignacion-->
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="IdIntervaloHoras">Hora de Reasignación</label>
                                        <ng-select [items]="listHoras"
                                                   bindLabel="HoraInicio"
                                                   bindValue="Id"
                                                   formControlName="IdIntervaloHoras"
                                                   loadingText="Cargando..."
                                                   [loading]="!listHoras"
                                                   notFoundText="Horas no encontradas"
                                                   placeholder="-- Seleccione una Hora de Reasignación --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdIntervaloHoras')">
                                        </ng-select>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </form>
